import React from "react";
import { ItemTypes } from "../Helper.js";
import FormBuilderElement from "./FormBuilderElement.js";
import { useDrop } from "react-dnd";

const FormBuilderListElements = ({
  formItems,
  moveCard,
  findCard,
  actionsContainer,
  buttonsColor,
  editFunction,
  activeField,
  maxHeightInputs,
  formInnerScroll,
  setFormItems,
}) => {
  const [, drop] = useDrop(() => ({ accept: ItemTypes.ExistElement }));
  return (
    <div
      className={`form-list-content ${
        !formInnerScroll ? "embed-dynamic-inputs-full-height" : ""
      }`}
      ref={drop}
      style={{
        maxHeight: formInnerScroll ? maxHeightInputs : "unset",
        minHeight: formInnerScroll ? maxHeightInputs : 330,
      }}
    >
      {formItems.map((item, index) => (
        <FormBuilderElement
          key={item.id}
          id={`${item.id}`}
          moveCard={moveCard}
          findCard={findCard}
          actionsContainer={actionsContainer}
          buttonsColor={buttonsColor}
          editFunction={editFunction}
          activeField={activeField}
          item={item}
          index={index}
          setFormItems={setFormItems}
          formItems={formItems}
        />
      ))}
    </div>
  );
};

export default FormBuilderListElements;
